import { UserRole } from "@smerf-gaming/types"
import axios, { AxiosError } from "axios"

export const getEventRoles = async (event_id: string): Promise<UserRole[] | null> => {
  try {
    const res = await axios.get(`/events/${event_id}/roles`)
    return res.data
  } catch (err) {
    console.log("getEventRoles  err", err)
  }
  return null
}

type response = { error?: string; message?: string }

export const addUserEventRole = async (user_id: string, event_id: string, role: string): Promise<response> => {
  try {
    const res = await axios.post<response>(`/events/${event_id}/roles`, { roles: [{ user_id, role }] })
    return res.data
  } catch (error) {
    return { error: error?.toString(), message: (error as AxiosError)?.response?.data?.message }
  }
}

export const removeUserEventRole = async (user_id: string, event_id: string): Promise<response> => {
  try {
    const res = await axios.delete<response>(`/events/${event_id}/roles/${user_id}`)
    return res.data
  } catch (error) {
    return { error: error?.toString(), message: (error as AxiosError)?.response?.data?.message }
  }
}
